/// Menu
import React, { Component, useContext, useEffect, useReducer, useState } from "react";
//import Metismenu from "metismenujs";
/// Scroll
import {  OverlayTrigger, Tooltip } from 'react-bootstrap'
import PerfectScrollbar from "react-perfect-scrollbar";
import Collapse from 'react-bootstrap/Collapse';
import Button from 'react-bootstrap/Button';

/// Link
import { Link, NavLink } from "react-router-dom";

import {useScrollPosition} from "@n8tb1t/use-scroll-position";
import { ThemeContext } from "../../../context/ThemeContext";
import { NavMenuToggle, NavMenuToggleSmallScreen } from "./NavHader";
import { useSelector } from "react-redux";


const reducer = (previousState, updatedState) => ({
  ...previousState,
  ...updatedState,
});

const initialState = {
  active : "",
  activeSubmenu : "",
}

const SideBar = () => {
const { permissionArr } = useSelector(state => state.auth)
const { permissions } = useSelector(state => state.permissionsData)


	const {
		iconHover,
		sidebarposition,
		headerposition,
		sidebarLayout,
	} = useContext(ThemeContext);

  const [state, setState] = useReducer(reducer, initialState);	

const [wrapper,setWrapper]=useState(false)
const [sidebarStyle, setSidebarStyle] = useState(false);

  // let handleheartBlast = document.querySelector('.heart');
  // function heartBlast(){
  //   return handleheartBlast.classList.toggle("heart-blast");
  // }
var mainwrapper=''
	useEffect(() => {
     mainwrapper = document.querySelector("#main-wrapper");
    const bodyElement = document.querySelector("body");
			setInterval(() => {
        if(mainwrapper.classList?.contains('menu-toggle')){
          setWrapper(true)
        }else{
          setWrapper(false)
        }
    if (bodyElement) {
      const sidebarStyleValue = bodyElement.getAttribute("data-sidebar-style");
      if(sidebarStyleValue==='mini'||sidebarStyleValue==='full'){
        setSidebarStyle(true)
      }else {
        setSidebarStyle(false)
      } 
    }
      }, 100);	
			
	}, [mainwrapper]);
 //For scroll
 	const [hideOnScroll, setHideOnScroll] = useState(true)
	useScrollPosition(
		({ prevPos, currPos }) => {
		  const isShow = currPos.y > prevPos.y
		  if (isShow !== hideOnScroll) setHideOnScroll(isShow)
		},
		[hideOnScroll]
	)

	// Menu dropdown list 
	//const [active , setActive] = useState('');
	//const [activeSubmenu , setActiveSubmenu] = useState('');

 
  const handleMenuActive = status => {
		
    setState({active : status});
		
		if(state.active === status){
			
      setState({active : ""});
    }
   
	}
	const handleSubmenuActive = (status) => {
		
    setState({activeSubmenu : status})
		if(state.activeSubmenu === status){
      setState({activeSubmenu : ""})
			
		}
    
	}
	// Menu dropdown list End

  /// Path
  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];
  
	const { menuToggle } = useContext(ThemeContext);
// Function to determine route based on menu item name
const getRoute = (menuName) => {
  switch(menuName) {
    case 'DashBoard':
      return '/';
    case 'Add Property':
      return 'addProperty';
    case 'List Property':
      return 'propertyList';
    case 'Vendor List':
      return 'vendorList';
    case 'Add Invoice':
      return 'addInvoice';
    case 'Invoice List':
      return 'invoiceList';
    case 'Invoice Verification':
      return 'invoiceVerification';
    case 'Permissions':
        return 'managePermissions';
    case 'Manage Permissions':
        return 'managePermissions'
            case 'Beneficiary Account Validation':
        return 'generateBankFile'
        case 'User Registration':
          return 'regUser';
        case 'Update Payment':
          return 'updatePayment';
    default:
      return '#'; // Default route or handle undefined routes
  }
};

// Function to transform menu data
const transformMenuData = (data) => {
  return permissions?.map(item => ({
    title: item.MenuItemName,
    classsChange: item.SubMenus.length ? 'mm-collapse' : '',
    iconStyle: <i className="material-icons" style={{color: 'black'}}>{item.MenuItemIcon}</i>,
    to: getRoute(item.MenuItemName),
    content: item.SubMenus.map(subMenu => ({
      title: subMenu.MenuItemName,
      to: getRoute(subMenu.MenuItemName),
      value: true, // Set based on your permissions or other conditions
      // content: subMenu.SubMenus.map(subSubMenu => ({
      //   title: subSubMenu.MenuItemName,
      //   to: getRoute(subSubMenu.MenuItemName),
      //   value: true
      // }))
    }))
  }));
};

const menuData = [
  // Your JSON data here
];
const MenuLists = transformMenuData(menuData);

  return (
    <div
      className={`deznav  border-right ${iconHover} ${
        sidebarposition.value === "fixed" &&
        sidebarLayout.value === "horizontal" &&
        headerposition.value === "static"
          ? hideOnScroll > 120
            ? "fixed"
            : ""
          : ""
      }`}
    >
      {/* <PerfectScrollbar className="deznav-scroll">          */}
        <div >  
        <div>  <ul className="metismenu" id="menu">
              {MenuLists?.map((data, index)=>{
                let menuClass = data.classsChange;
                  if(menuClass === "menu-title"){
                    return(
                        <li className={menuClass}  key={index} >{data.title}</li>
                    )
                  }else{
                    return(				
                      <li  className={` ${ state.active === data.title ? 'mm-active' : ''}`}
                        key={index} 
                      >
                        {data.content && data.content.length > 0 ?
                       (menuToggle ?
                            <Link to={"#"} 
                              className="has-arrow"
                              style={{color:'black'}}
                              onClick={() => {  handleMenuActive(data.title)}}
                            >								
								                {data.iconStyle}
                                <span className="nav-text">{data.title}</span>
                            </Link>
                           : <Link to={"#"} 
                              className="has-arrow"
                              onClick={() => {  handleMenuActive(data.title)}}
                            >								
								                {data.iconStyle}
                                <span className="nav-text">{data.title}</span>
                            </Link>)
                        :
                       (menuToggle ? 
                     
                          <NavLink  to={data.to} onClick={() => NavMenuToggleSmallScreen()} style={{color:'black'}} >
                              {data.iconStyle}
                              <span className="nav-text">{data.title}</span>
                          </NavLink>
                     :   <NavLink  to={data.to} onClick={() => NavMenuToggleSmallScreen()}>
                              {data.iconStyle}
                              <span className="nav-text">{data.title}</span>
                          </NavLink>)
                        }
                     { data.content?.length >0   &&  <Collapse in={state.active === data.title ? true :false}>
                          <ul className={`${menuClass === "mm-collapse" ? "mm-show" : ""}`}>
                            {data.content?.length >0  && data.content.map((data,index) => {									
                              return(	
                                 data?.value && <li key={index}
                                    className={`${ state.activeSubmenu === data.title ? "mm-active" : ""}`}                                    
                                  >
                                    {data.content && data.content.length > 0 ?
                                        <>
                                          <NavLink to={data.to} className={data.hasMenu ? 'has-arrow' : ''}
                                            onClick={() => { handleSubmenuActive(data.title)}}
                                          >
                                            {data.title}
                                          </NavLink>
                                          <Collapse in={state.activeSubmenu === data.title ? true :false}>
                                              <ul className={`${menuClass === "mm-collapse" ? "mm-show" : ""}`}>
                                                {data.content && data.content.map((data,index) => {
                                                  return(	
                                                    <>
                                                      <li key={index}>
                                                        <Link className={`${path === data.to ? "mm-active" : ""}`} to={data.to}>{data.title}</Link>
                                                      </li>
                                                    </>
                                                  )
                                                })}
                                              </ul>
                                          </Collapse>
                                        </>
                                      :
                                      <Link onClick={() => NavMenuToggleSmallScreen()} to={data.to}>
                                        {data.title}
                                      </Link>
                                    }
                                    
                                  </li>
                                
                              )
                            })}
                          </ul>
                        </Collapse>}
                        {  sidebarLayout.value === "vertical"&&wrapper===true&&sidebarStyle===true?<>
                      <div className="text-center">
                        {data.title}
                      </div>
                        </>:''}
                      </li>	
                    )
                }
              })}          
          </ul></div>	

         
         <div style={{position:'absolute',bottom:'20px',alignItems:'center',justifyContent:'center',display:'flex',width:'100%',cursor:'pointer'}}>
         <i className="material-icons"  style={{color:'black'}}onClick={()=>{NavMenuToggle()}}>more_horiz</i>
     
         </div>
           </div>
        {/* </PerfectScrollbar> */}
      </div>
    );
};

export default SideBar;
